module.exports = __webpack_public_path__ + "static/media/Segment7.771cddc9.jpg";